export const statesAU = [
	{
		'name': 'Australian Capital Territory', 'isoCode': 'ACT', 'countryCode': 'AU', 'latitude': '-35.47346790', 'longitude': '149.01236790'
	}, {
		'name': 'New South Wales', 'isoCode': 'NSW', 'countryCode': 'AU', 'latitude': '-31.25321830', 'longitude': '146.92109900'
	}, {
		'name': 'Northern Territory', 'isoCode': 'NT', 'countryCode': 'AU', 'latitude': '-19.49141080', 'longitude': '132.55096030'
	}, {
		'name': 'Queensland', 'isoCode': 'QLD', 'countryCode': 'AU', 'latitude': '-20.91757380', 'longitude': '142.70279560'
	}, {
		'name': 'South Australia', 'isoCode': 'SA', 'countryCode': 'AU', 'latitude': '-30.00023150', 'longitude': '136.20915470'
	}, {
		'name': 'Tasmania', 'isoCode': 'TAS', 'countryCode': 'AU', 'latitude': '-41.45451960', 'longitude': '145.97066470'
	}, {
		'name': 'Victoria', 'isoCode': 'VIC', 'countryCode': 'AU', 'latitude': '-36.48564230', 'longitude': '140.97794250'
	}, {
		'name': 'Western Australia', 'isoCode': 'WA', 'countryCode': 'AU', 'latitude': '-27.67281680', 'longitude': '121.62830980'
	}
];
